const PortalConfig = {
  manager: {
    userValue: "public_manager",
    loginRoute: "/login-manager",
    forgotPasswordRoute: "/forgot-password",
    signUpRoute: "/sign-up",
    requestSubmittedRoute: "/request-submitted",
    loginHeading: "Fleet Manager",
    loginSubmitLabel: "Sign in",
    loginBackSetsUserOnly: false,
    loginTwoFactorTitle: "Protected by 2FA",
    loginTwoFactorSubtitle: "Verification will be required next step.",
    loginTenantTypes: ["fleet_manager"],
    expectedTenantTypes: ["fleet_manager"],
    roleLabel: "Fleet Manager",
    reviseRoute: "/fleet-manager/revise",
    reviseTenantType: "fleet_manager",
    reviseChecksBeforePortal: true,
    fallbackPortal: {
      userType: "manager",
      dashboardRoute: "/dashboard-manager",
    },
  },
  admin: {
    userValue: "public_admin",
    loginRoute: "/login-admin",
    forgotPasswordRoute: "/forgot-password",
    signUpRoute: null,
    requestSubmittedRoute: null,
    loginHeading: "Fleet Admin",
    loginSubmitLabel: "Sign in",
    loginBackSetsUserOnly: false,
    loginTwoFactorTitle: "Protected by 2FA",
    loginTwoFactorSubtitle: "Verification will be required next step.",
    loginTenantTypes: ["admin"],
    expectedTenantTypes: ["admin"],
    roleLabel: "Admin",
    reviseRoute: null,
    reviseTenantType: null,
    reviseChecksBeforePortal: true,
    fallbackPortal: { userType: "admin", dashboardRoute: "/dashboard-admin" },
  },
  vendor: {
    userValue: "public_vendor",
    loginRoute: "/login-vendor",
    forgotPasswordRoute: "/forgot-password-vendor",
    signUpRoute: "/sign-up-vendor",
    requestSubmittedRoute: "/request-submitted-vendor",
    loginHeading: "Fuel Vendor",
    loginSubmitLabel: "Login",
    loginBackSetsUserOnly: true,
    loginTwoFactorTitle: "Two Factor Authentication",
    loginTwoFactorSubtitle: "An OTP will be sent to your registered email",
    loginTenantTypes: ["fuel_vendor"],
    expectedTenantTypes: ["fuel_vendor"],
    roleLabel: "Fuel Vendor",
    reviseRoute: "/fuel-vendor/revise",
    reviseTenantType: "fuel_vendor",
    reviseChecksBeforePortal: false,
    fallbackPortal: { userType: "vendor", dashboardRoute: "/dashboard-vendor" },
  },
};

const RESET_PASSWORD_PORTAL_KEY = "resetPasswordPortal";

const setResetPasswordPortal = (portal) => {
  try {
    localStorage.setItem(RESET_PASSWORD_PORTAL_KEY, portal);
  } catch {}
};

const getResetPasswordPortal = () => {
  try {
    const portal = localStorage.getItem(RESET_PASSWORD_PORTAL_KEY);
    return PortalConfig[portal] ? portal : null;
  } catch {
    return null;
  }
};

const clearResetPasswordPortal = () => {
  try {
    localStorage.removeItem(RESET_PASSWORD_PORTAL_KEY);
  } catch {}
};

export {
  setResetPasswordPortal,
  getResetPasswordPortal,
  clearResetPasswordPortal,
};
export default PortalConfig;
